import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { addData } from '../../helpers/fackBackend_Helper';

function* getOutsideEmialResponse({ payload: { searchData } }) {
    try {
        const response = yield call(addData, '/getoutsideEmailInbox', searchData);
        if (response.response.Status) {
            yield put(actions.getOutsideEmailSuccess(response.response.data));
        } else {
            yield put(actions.getOutsideEmailFail(response.response.Message));
        }
    } catch (error) {
        yield put(actions.getOutsideEmailFail(error.message));
    }
}

function* readOutsideEMailResponse({ payload: { mailID } }) {
    try {
        const response = yield call(addData, '/outsideReadMail/' + mailID);
        if (response.response.Status) {
            yield put(actions.readOutsideMailSuccess(response.response.Message, mailID));
        } else {
            yield put(actions.readOutsideEMailFail(response.response.Message));
        }
    } catch (error) {
        yield put(actions.readOutsideEMailFail(error.message));
    }
}

export default function* rootSaga() {
    yield all([takeEvery(actions.GET_OUTSIDE_EMAIL, getOutsideEmialResponse)]);
    yield all([takeEvery(actions.READ_OUTSIDE_EMAIL, readOutsideEMailResponse)]);
}
